import { LockKeyhole, Sprout } from "lucide-react";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { resetPassword } from "../lib/api";

export function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") ?? "";
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    if (password.length < 6) {
      return;
    }
    setSubmitting(true);
    setError("");
    try {
      await resetPassword(token, password);
      setDone(true);
      setTimeout(() => navigate("/"), 1200);
    } catch (e) {
      setError(e instanceof Error ? e.message : "Đặt lại thất bại.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-paper px-4 py-10 text-ink">
      <section className="w-full max-w-md rounded-lg border border-line bg-white shadow-panel">
        <div className="flex items-center gap-3 border-b border-line px-5 py-4">
          <div className="flex h-10 w-10 items-center justify-center rounded-lg border border-blue-100 bg-blue-50 text-brand">
            <Sprout size={21} aria-hidden="true" />
          </div>
          <div>
            <h1 className="text-lg font-bold">Đặt mật khẩu mới</h1>
            <p className="text-sm font-medium text-muted">Human Note</p>
          </div>
        </div>

        <div className="space-y-3 p-5">
          {!token ? (
            <p className="rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-sm font-semibold text-rose-700">
              Thiếu mã đặt lại. Hãy mở lại link trong email.
            </p>
          ) : done ? (
            <p className="rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-sm font-semibold text-emerald-700">
              Đã đổi mật khẩu! Đang đưa bạn vào app...
            </p>
          ) : (
            <>
              <div>
                <label className="mb-1 block text-sm font-bold">Mật khẩu mới (ít nhất 6 ký tự)</label>
                <div className="flex h-11 items-center rounded-lg border border-line bg-slate-50 px-3 text-muted">
                  <LockKeyhole size={17} aria-hidden="true" />
                  <input
                    className="h-full min-w-0 flex-1 border-0 bg-transparent px-3 text-sm font-semibold text-ink outline-none placeholder:text-slate-400"
                    type="password"
                    value={password}
                    onChange={(event) => setPassword(event.target.value)}
                    onKeyDown={(event) => {
                      if (event.key === "Enter") {
                        void submit();
                      }
                    }}
                    placeholder="••••••••"
                    autoComplete="new-password"
                  />
                </div>
              </div>
              {error ? (
                <p className="rounded-lg border border-red-200 bg-red-50 px-3 py-2 text-sm font-semibold text-red-700">{error}</p>
              ) : null}
              <button
                className="inline-flex h-11 w-full items-center justify-center gap-2 rounded-lg bg-brand px-4 text-sm font-bold text-white hover:bg-blue-700 disabled:bg-slate-300"
                type="button"
                disabled={password.length < 6 || submitting}
                onClick={submit}
              >
                {submitting ? "Đang đặt lại" : "Đặt mật khẩu mới"}
              </button>
            </>
          )}
        </div>
      </section>
    </main>
  );
}
